export const MAX_QUANTITY = 9999999; // 7 times "9"
export const MAX_QUANTITY_LENGTH = MAX_QUANTITY.toString().length;
export const MAX_QUANTITY_FORMAT = "9.999.999";
export const MAX_QUANTITY_FORMAT_LENGTH = MAX_QUANTITY_FORMAT.length;
export const MAX_TEXT_LENGTH_CONTACT_FORMS = 2000;
export const WEIGHT_DECIMAL_DIGITS = 3;
export const DEFAULT_UNIT_SYMBOL = "kg";
export const DEFAULT_LANGUAGE = window.SCHA.config.fallbackLanguage || "en";
export const DEFAULT_FRACTION_DIGITS = 2;
export const CURRENT_LANGUAGE = window.SCHA.config.language || DEFAULT_LANGUAGE;
export const AVAILABLE_LANGUAGES = window.SCHA.config.availableLanguages;

export const SELF_DISMISSABLE_TOASTS_TOP = 7000; // 7000 ms -> 7s

export const FORMATTING_LOCALE_CODE = window.SCHA.config.formattingLocale || "en";
export const ENGLISH_LOCALE_CODE = "en";
export const FALLBACK_DECIMAL_SEPARATOR = ",";
export const FALLBACK_THOUSAND_SEPARATOR = ".";
export const FALLBACK_DATE_FORMAT = "DD.MM.YYYY";
export const FALLBACK_DATETIME_FORMAT = "DD.MM.YYYY hh:mm";
export const FALLBACK_TIME_FORMAT = "hh:mm";

export const PO_NUMBER_LENGTH = 35;
export const ACCOUNT_NUMBER_LENGTH = 35;

export const ORDER_COMMENT_LENGTH = 512;

export const AUTOSUGGEST_DEBOUNCE_TIME = 300;
export const AUTOSUGGEST_MAX_LENGTH = 5;

export const CADTABLE_DEBOUNCE_TIME = 900;

export const SALES_REP_PHONE_NO = window.SCHA.config.salesRepPhone;

export const CURRENCY_ISO = window.SCHA.config.currencyIso || "GBP";
export const INVALID_PACKAGE_CODE = "XX";

export const QUOTE_ENTRY_REJECTED = "EV01";
export const QUOTE_ENTRY_IN_CLARIFICATION = "IV01";

export const SEARCH_SCROLL_DEBOUNCE_TIME = 250;
export const EDIT_USER_URL = "/my-company/organization-management/manage-users/edit/";

export const DEFAULT_FILTER_CONFIG = "DEFAULT";

// If there are more products in cart than this amount
export const CART_PNA_THRESHOLD = window.SCHA.config.maxCartSizeWithPnaCall;

export const MAX_COLUMNS_IN_TABULAR_VIEW = 7;

export const EXPRESS_DELIVERY_CODE = "EXPRESS";

export const HAS_END_CUSTOMER = window.SCHA.config.hasEndCustomer;

export const GOOGLE_GEOAPI_KEY = window.SCHA.config.googleGeocodingKey;

// depends on how many price scales we will have from backend
// Substracting 1 so it's 1-based for configurator while 0-based for code
export const MAX_VISIBLE_PRICE_SCALE = (window.SCHA.config.maxVisiblePriceScale || 0) - 1;

export const EMAIL_PATTERN = /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-']+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

export const CAPTCHA_SITE_KEY = window.SCHA.config.captchaSiteKey;
export const CAPTCHA_SITE_KEY_FIELD = "g-recaptcha-response";
export const CAPTCHA_SERVER_ERROR = "recaptcha.challenge.field.invalid";
export const CAPTCHA_ENABLED = window.SCHA.config.captchaEnabled;

export const MOUNTING_TAB = "productDetailsPage.tabs.mounting";
export const MOUNTING_INFORMATION_TAB = "productDetailsPage.tabs.mountinginformation";
export const MOUNTING_MANAGER_TAB = "productDetailsPage.tabs.mountingmanager";

export const SHARE_LINEAR_CONFIGURATIONS_CODE_SEPARATOR = ",";

export const ENGLISH_LANGUAGE = "en";
export const GERMAN_LANGUAGE = "de";
export const ENGLISH_EXTERNAL_CONTENT_SUFFIX = "_en-GB.html";
export const GERMAN_EXTERNAL_CONTENT_SUFFIX = "_de-DE.html";
export const KITS_MODAL_LAYOUT_REQUEST_PARAM = "?modalCls=scha__lc__kits-table";

const siteCode = window.SCHA.config.siteUid.slice(-2).toLowerCase();
export const REMOVE_SALES_PARTNER_FINDER = siteCode === "cn";

export const IS_US_SITE = siteCode === "us";

export const URL_LANGUAGE_PARAM = "lang";

export const HEADER_BREAKPOINT_LOGO = 600;
export const MQ_HEADER_BREAKPOINT_LOGO = `(min-width:${HEADER_BREAKPOINT_LOGO}px)`;

const NAV_BAR_HEIGHT_PHONE = 48;
const NAV_BAR_HEIGHT_TABLET = 48;
const NAV_BAR_HEIGHT_DESKTOP = 67;

const SCHA_LOGO_HEIGHT_S = 17;
const SCHA_LOGO_HEIGHT_M = 23;

/* special case - 320-599px */
export const HEADER_HEIGHT_PHONE = `${SCHA_LOGO_HEIGHT_S * 3 + NAV_BAR_HEIGHT_PHONE}px`;
export const REGION_BAR_HEIGHT_PHONE = `165px`;
/* special case - 600px-tablet */
export const HEADER_HEIGHT_PHONE_BIG = `${SCHA_LOGO_HEIGHT_M * 3 + NAV_BAR_HEIGHT_PHONE}px`;
export const HEADER_HEIGHT_TABLET = `${SCHA_LOGO_HEIGHT_M * 3 + NAV_BAR_HEIGHT_TABLET}px`;
export const HEADER_HEIGHT_DESKTOP = `${SCHA_LOGO_HEIGHT_M * 3 + NAV_BAR_HEIGHT_DESKTOP}px`;
export const REGION_BAR_HEIGHT = `80px`;

export const WIDE = "wide";
export const NARROW = "narrow";

export const _BLANK = "_BLANK";
export const BLANK = "BLANK";

export const PRODUCT_VARIANT_TABLE_TOGGLE_THRESHOLD = 7;
export const SEARCH_TECH_VALUE_TABLE_THRESHOLD = 5;

// PDP - Downloads Tab - Publication on page (desktop / mobile)
export const PUBS_ON_DESKTOP = 40;
export const PUBS_ON_MOBILE = 10;

export const MOVING_IMAGE_COOKIE_CONSENT_GROUP = "C0002";

// Number of days from today in which a delivery date can be selected
export const DELIVERY_DATE_OFFSET = window.SCHA.offsetRDD;

export const BEARINGX_API_URL = window.SCHA.bearingXUrl;

export const BATCHING_INTERVAL = window.SCHA.batching.interval;
export const BATCHING_SIZE_RESET_TIME = window.SCHA.batching.sizeResetTime;
export const BATCHING_PRICE_ENABLED = window.SCHA.batching.pna.pEnabled;
export const BATCHING_AVAILABILITY_ENABLED = window.SCHA.batching.pna.aEnabled;
export const BATCHING_PNA_BATCHES = window.SCHA.batching.pna.batches;
export const BATCHING_UPDATE_LINEITEM_ENABLED = window.SCHA.batching.lineItemUpdate.enabled;
export const BATCHING_UPDATE_LINEITEM_BATCHES = window.SCHA.batching.lineItemUpdate.batches;

// Special characters

export const NBSP = "\xa0";
export const NON_BREAKING_HYPHEN = "\u2011";

export const DST_PRODUCT_CODE = "DST";
export const DST_SAP_MAT_NO = "0952597240000";

//CC
export const CC_MIN_JS_FILE_URL = window.SCHA.ccMinJSFileURL;

export const EMPTY_JOB_TITLE_CODE = "1001";

// Customer categories
export const CUSTOMER_CATEGORY = "cc_customer";
export const DISTRIBUTOR_CATEGORY = "cc_distributor";
export const SERVICE_PROVIDER_CATEGORY = "cc_service_provider";
export const SCHAEFFLER_INTERNAL_CATEGORY = "cc_schaeffler_internal";
